// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

// const CouponBanner = () => {
//   const offers = [
//     { id: 1, text: "20% OFF FIRST ORDER • Code: WELCOME20", icon: "🔥", highlight: "WELCOME20" },
//     { id: 2, text: "FREE SHIPPING OVER ₹499 • Code: FREESHIP", icon: "🚚", highlight: "FREESHIP" },
//     { id: 3, text: "BUY 1 GET 1 FREE • Code: BOGO", icon: "🎁", highlight: "BOGO" }
//   ];

//   const [currentOffer, setCurrentOffer] = useState(0);
//   const [isCopied, setIsCopied] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentOffer((prev) => (prev + 1) % offers.length);
//       setIsCopied(false);
//     }, 4000);
//     return () => clearInterval(interval);
//   }, []);

//   const copyToClipboard = (text) => {
//     navigator.clipboard.writeText(text);
//     setIsCopied(true);
//     setTimeout(() => setIsCopied(false), 2000);
//   };

//   return (
//     <div className="bg-purple-800 text-white w-full h-12 flex items-center fixed top-0 z-40">
//       <div className="w-full max-w-7xl mx-auto px-8 relative">
//         {/* Navigation Arrows - Fixed Positioning */}
//         <button 
//           onClick={() => setCurrentOffer((p) => (p - 1 + offers.length) % offers.length)}
//           className="absolute left-2 top-1/2 -translate-y-1/2 p-1 hover:bg-purple-700 rounded-full z-50"
//         >
//           <FiChevronLeft className="w-4 h-4" />
//         </button>

//         <button 
//           onClick={() => setCurrentOffer((p) => (p + 1) % offers.length)}
//           className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-purple-700 rounded-full z-50"
//         >
//           <FiChevronRight className="w-4 h-4" />
//         </button>

//         {/* Offer Content - Centered */}
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={offers[currentOffer].id}
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             transition={{ duration: 0.3 }}
//             className="flex items-center justify-center gap-2 w-full"
//           >
//             <span className="text-sm">{offers[currentOffer].icon}</span>
//             <p className="text-xs sm:text-sm whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[60vw] sm:max-w-[50vw]">
//               {offers[currentOffer].text}
//             </p>
//             <button
//               onClick={() => copyToClipboard(offers[currentOffer].highlight)}
//               className={`px-2 py-1 rounded text-xs sm:text-sm font-medium shrink-0 bg-purple-700 hover:bg-purple-600`}
//             >
//               {isCopied ? 'Copied!' : 'Copy'}
//             </button>
//           </motion.div>
//         </AnimatePresence>
//       </div>
//     </div>
//   );
// };

// export default CouponBanner;
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig'; // adjust path if needed

const iconMap = {
  bogo: "🎁",
  discount: "🔥",
  shipping: "🚚",
  default: "💸"
};

const CouponBanner = ({onMount}) => {
  const [offers, setOffers] = useState([]);
  const [currentOffer, setCurrentOffer] = useState(0);
  const [isCopied, setIsCopied] = useState(false);

  // Fetch offers from Firestore
  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'offers'));
        const fetchedOffers = [];

        querySnapshot.forEach(doc => {
          const data = doc.data();
          if (data.enabled) {
            const icon = iconMap[data.type?.toLowerCase()] || iconMap.default;
            const text = `${data.title} • Code: ${data.code}`;
            fetchedOffers.push({
              id: doc.id,
              text,
              icon,
              highlight: data.code
            });
          }
        });

        setOffers(fetchedOffers);
      } catch (error) {
        console.error("Error fetching offers:", error);
      }
    };

    fetchOffers();
  }, []);
  useEffect(() => {
    if (offers.length > 0 && typeof onMount === 'function') {
      onMount(true);  // Notify parent it's ready
    }
  }, [offers, onMount]);
  // Auto-scroll offers
  useEffect(() => {
    if (offers.length === 0) return;
    const interval = setInterval(() => {
      setCurrentOffer(prev => (prev + 1) % offers.length);
      setIsCopied(false);
    }, 4000);
    return () => clearInterval(interval);
  }, [offers]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  if (offers.length === 0) return null; // hide banner if no offers

  return (
    // <div className="bg-purple-800 text-white w-full h-12 flex items-center lg:fixed top-0 z-40">
    <div className="h-8 w-full bg-black text-white text-xs flex items-center justify-center px-2 z-50 lg:fixed top-0 left-0 right-0 transition-all duration-300">

      <div className="w-full max-w-7xl mx-auto px-8 relative">

        {/* Navigation Arrows */}
        <button
          onClick={() => setCurrentOffer((p) => (p - 1 + offers.length) % offers.length)}
          className="absolute left-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-700 rounded-full z-50"
        >
          <FiChevronLeft className="w-4 h-4" />
        </button>

        <button
          onClick={() => setCurrentOffer((p) => (p + 1) % offers.length)}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-700 rounded-full z-50"
        >
          <FiChevronRight className="w-4 h-4" />
        </button>

        {/* Offer Content */}
        <AnimatePresence mode="wait">
          <motion.div
            key={offers[currentOffer].id}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="flex items-center justify-center gap-2 w-full"
          >
            <span className="text-sm">{offers[currentOffer].icon}</span>
            <p className="text-[10px] sm:text-xs md:text-sm whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[60vw] sm:max-w-[50vw]">
              {offers[currentOffer].text}
            </p>
            {/* <button
              onClick={() => copyToClipboard(offers[currentOffer].highlight)}
              className="px-2 py-1 rounded text-xs sm:text-sm font-medium shrink-0 bg-gray-700 hover:bg-gray-600"
            >
              {isCopied ? 'Copied!' : 'Copy'}
            </button> */}
            <button
              onClick={() => copyToClipboard(offers[currentOffer].highlight)}
              className="px-2 py-0.5 rounded border border-white text-white bg-gray-900 hover:bg-gray-400 hover:text-black transition-colors duration-200 text-[10px] sm:text-xs font-semibold shrink-0"
            >
              {isCopied ? 'Copied!' : 'Copy'}
            </button>

          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CouponBanner;
